import { useState } from 'react';
import { Box } from 'reflexbox';

import {
	IdentityProvider,
	User,
	useEnsureAssociatedIdentitiesMutation,
} from '@treams/treams-network';
import { Switch } from '@treams/treams-ui';

import BulkModal from './BulkModal';
import BulkSSOIdentityProvider from './BulkSSOIdentityProvider';

export default function BulkSingleSignOnModal(props: { users: User[]; onDismiss: () => void }) {
	const [ensure] = useEnsureAssociatedIdentitiesMutation();
	const [identityProvider, setIdentityProvider] = useState<IdentityProvider['id']>();

	const [enabled, setEnabled] = useState(false);

	return (
		<BulkModal
			name="bulkSingleSignOn"
			onDismiss={props.onDismiss}
			valid={Boolean(identityProvider)}
			users={props.users}
			apply={async (user) => {
				await ensure({
					variables: {
						input: {
							userID: user.id,
							identityProviderID: identityProvider!,
							names: enabled ? [user.username, user.email] : [],
						},
					},
				});
			}}
		>
			<Box mb={3}>
				<BulkSSOIdentityProvider onChange={setIdentityProvider} />
			</Box>
			<Box>
				<Switch
					on={enabled}
					onChange={() => setEnabled(!enabled)}
					label="With Treams Single Sign-On, this employee can login directly through their company
						account."
				/>
			</Box>
		</BulkModal>
	);
}
